<template>
  <div class="archivesWorkPaddy">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>年次レポート / {{ year }} 年 / 作業実績 / ほ場内</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">履歴 / {{ year }} 年 / 作業実績</h1> -->
    </div>
    <div class="button-area" v-if="displayDataCreated">
      <span class="btn-submit" @click="excelDownload">Excelダウンロード</span>
      <span class="btn-submit" :disabled="isPolling" @click="excelWithImageRequest">
        <span class="button-text">Excelダウンロード(画像有)</span>
        <!-- ポーリング中だけスピナーを重ねる -->
        <div v-if="isPolling" class="spinner-overlay">
          <div class="spinner"></div>
        </div>
      </span>
      <span class="message-submit">※ 画像有のダウンロードには時間がかかります ※</span>
      <input
        id="box1"
        type="checkbox"
        v-model="displayAllItemDetails"
        @change="displayToggle"
      />
      <label for="box1">全項目表示</label>
      <!-- <input
        id="box2"
        type="checkbox"
        v-model="displayAllWorks"
        @change="displayToggleWorks"
      />
      <label for="box2" id="label2">ほ場外作業表示</label> -->
    </div>
    <div class="message-area" v-if="errorMessage">
      <p class="error-message">{{errorMessage}}</p>
    </div>
    <div class="table-section">
      <div class="container">
        <table>
          <thead>
            <template v-if="headers[1].length == paddyHeaders.length">
              <tr>
                <th
                  v-for="(header_row, row_id) in headers[1]"
                  v-bind:key="row_id"
                  v-bind:class="header_row.class"
                  v-bind:style="header_row.style"
                >
                  {{ header_row.value }}
                </th>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(header_row, row_id) in headers" v-bind:key="row_id">
                <th
                  v-for="(header, item_id) in header_row"
                  v-bind:key="item_id"
                  v-bind:class="header.class"
                  v-bind:style="header.style"
                >
                  {{ header.value }}
                </th>
              </tr>
            </template>
          </thead>
          <tbody>
            <tr
              v-for="(row, row_id) in items"
              v-bind:key="row_id"
              v-bind:id="'row_id' + row_id"
            >
              <template v-for="(item, item_id) in row">
                <td
                  v-if="item.image"
                  v-bind:key="item_id"
                  v-bind:class="item.class"
                  v-bind:style="item.style"
                  @click="displayImage(item)"
                >
                  <div class="ic-images" />
                </td>
                <td
                  v-else
                  v-bind:key="item_id"
                  v-bind:class="item.class"
                  v-bind:style="item.style"
                >
                  {{ item.value }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      v-if="showImages"
      class="image-frame-container"
    >
      <transition name="scale" appear>
        <div class="image-frame">
          <div class="image-title-area">
            <div />
            <div class="btn-close" @click="hideImages"></div>
          </div>
          <section class="section">
            <div
              :class="{
                container: true,
                center: showImageUrls.length === 1,
              }"
            >
              <div v-for="(row, index) in showImageUrls" :key="index">
                <img :src="row" />
              </div>
            </div>
          </section>
          <div class="image-footer-area"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import Loader from "@/mixins/loader";
import { Storage } from "aws-amplify";
import BigNumber from "bignumber.js";

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      dowdData: {
        seasons: [],
        paddyFields: [],
      },
      year: null,
      management_id: null,

      displayAllItemDetails: false,
      displayAllWorks: false,
      hideColumns: [],
      hideRows: [],
      hdeStyle: null,

      displayDataCreated: false,
      paddyHeaders: [
        {
          key: "no",
          value: "#",
          class: "fixed04 no-cell",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
        {
          key: "name",
          value: "ほ場名",
          class: "fixed04 paddy-name-cell",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
        {
          key: "kousakusha",
          value: "耕作者",
          class: "fixed03",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
        {
          key: "brand",
          value: "栽培品種",
          class: "fixed03",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
        {
          key: "area",
          value: "面積 [a]",
          class: "fixed03",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
        {
          key: "tag_no",
          value: "センサー",
          class: "fixed03",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
        {
          key: "remarks",
          value: "メモ",
          class: "fixed03",
          style: {
            "--before-border": "solid 1px #ddd",
          },
        },
      ],
      headers: [[], []],
      items: [],
      // 画像表示
      showImages: false,
      // 画像パス
      showImageUrls: [],
      // 年次レポートポーリング関連
      intervalId: null,
      timeoutId: null,
      isPolling: false,
      errorMessage: null,
      // マウント状況（false: マウントされていない, true: マウントされている）
      isMounted: false,
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      this.isMounted = true;
      this.management_id = await this.getCurrentManagementId();
      this.year = await this.getCurrentYear();
      await this.loadData();
      await this.createDownloadData();
      await this.initHideStyle();
      await this.excelWithImagePollingStart();
    });
  },

  async beforeDestroy() {
    this.isMounted = false;
    this.destroyStyle();
    this.stopPolling('ページを離れた');
  },

  methods: {
    ...mapActions([
      "retrieveSeasons",
      "retrievePaddyFields",
      "showWorkHistories",
      "retrievePaddyFieldHistories",
      "retrieveGlobalWorkHistories",
      "workRequest",
      "workMonitoring",
      "resetPollingParams",
    ]),
    ...mapGetters([
      "getPaddyFields", 
      "getCurrentManagementId", 
      "getCurrentYear",
      "getPollingParams",
    ]),

    /** 全データをダウンロードする */
    excelDownload() {
      var ws_data = [];
      // ヘッダ
      for (const row of this.headers) {
        let rowValue = [];
        for (const item of row) {
          rowValue.push(item.value);
        }
        ws_data.push(rowValue);
      }
      // データ
      for (const row of this.items) {
        let rowValue = [];
        for (const item of row) {
          rowValue.push(item.value);
        }
        ws_data.push(rowValue);
      }

      // 数値項目の列番号抽出
      var columns = [];
      var rowdata = this.headers[1];
      for (var i = 0; i < rowdata.length; i++) {
        if (rowdata[i].detail && rowdata[i].detail.item_detail_type === "num") {
          columns.push(i);
        }
      }
      // 面積の追加
      columns.push(4);

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      for (const col of columns) {
        var maxRow = ws_data.length;
        var startRow = this.headers.length;
        for (var row = startRow; row < maxRow; row++) {
          var add = XLSX.utils.encode_cell({ r: row, c:col });
          var cell = ws[add];
          if (cell) {
            if (cell.v != null && cell.v.length > 0) {
              const _val = new BigNumber(cell.v);
              if (_val.isNaN(cell.v)) {
                continue;
              }
            }
            // 数値
            cell.t = 'n';
          }
        }
      }
      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_history_" +
        this.getStringFromDate(dt) +
        ".xlsx";
      link.click();
    },

    /** エクセル作成をリクエストする */
    async excelWithImageRequest() {
      this.errorMessage = null;
      this.isPolling = true;
      
      const pollingParams = this.getPollingParams()
      // 処理中の場合はリターンする
      if (pollingParams) {
        return;
      }

      // 作成開始のリクエストをする
      const res = await this.workRequest();
//      console.log('resReq', res);
      if (!res) {
        this.errorMessage = "ダウンロードできませんでした。\n再度お試しください。";
        this.stopPolling();
        return;
      }

      this.excelWithImagePollingStart();
    },

    /** エクセルのポーリング開始 */
    async excelWithImagePollingStart() {
      this.errorMessage = null;
      const pollingParams = this.getPollingParams();
      if (!pollingParams) {
        return;
      }
      this.isPolling = true;

      // まず1回取得を試みる
      const isFinished = await this.excelWithImagePolling();
      if (isFinished) {
        // エクセルの作成が完了していれば処理を終了する
        this.isPolling = false;
        return;
      }

      // ポーリング処理を開始する
//      console.log("ポーリング開始");
      this.intervalId = setInterval(this.excelWithImagePolling, 5000); // 5秒おきに実行
      
      // タイムアウト設定（マイナスになると即実行される）
      let timeoutSeconds = pollingParams.timeoutSeconds - Date.now();
      this.timeoutId = setTimeout(() => {
        this.errorMessage = "タイムアウトしました。\n時間を置いてから再度お試しください。";
        this.resetPollingParams();
        this.stopPolling(`時間制限`);
      }, timeoutSeconds);
    },

    /** 
     * エクセルのポーリング
     * return true: 作成完了している, false: 作成完了以外
     */
    async excelWithImagePolling() {
      let isFinished = false;

      // isMountedで判定する
      if (!this.isMounted) {
        this.stopPolling("画面から離れている");
        return isFinished;
      }

//      console.log("ポーリング中");
      const res = await this.workMonitoring();
//      console.log('resMoni', res);

      switch (res.status) {
        case 2:
          this.stopPolling('正常終了');
          this.triggerDownload(res.download_url, res.filename);
          this.resetPollingParams();
          isFinished = true;
          break;

        case 9:
          this.stopPolling('異常終了');
          this.resetPollingParams();
          this.errorMessage = "ダウンロードできませんでした。\n再度お試しください。";
          isFinished = true;
          break;
      
        default:
          // 0: 未処理
          // 1: 処理中
          break;
      }

      return isFinished;
    },

    /** urlのファイルをダウンロードする */
    async triggerDownload(url, filename = '') {
//      console.log(`${filename}, ${url}`)
      if (!(url && filename)) {
        this.errorMessage = "ダウンロードできませんでした。\n再度お試しください。";
        return;
      }
      const a = document.createElement('a');
      a.href = url;
      if (filename) {
        a.download = filename; // これがあると「保存」ダイアログが表示されずに進む
      }
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    stopPolling(reason) {  // eslint-disable-line no-unused-vars
      this.isPolling = false;
      
      if (!this.intervalId && !this.timeoutId) {
        return;
      }

      clearInterval(this.intervalId);
      clearTimeout(this.timeoutId);

      this.intervalId = null;
      this.timeoutId = null;

//      console.log(`ポーリング終了（${reason}）`);
    },

    /** Dateから YYYYMMDDhhmmss 形式に変換して返す */
    getStringFromDate(date) {
      var year_str = date.getFullYear();
      var month_str = date.getMonth() + 1;
      var day_str = date.getDate();
      var hour_str = date.getHours();
      var minute_str = date.getMinutes();
      var second_str = date.getSeconds();

      month_str = ("0" + month_str).slice(-2);
      day_str = ("0" + day_str).slice(-2);
      hour_str = ("0" + hour_str).slice(-2);
      minute_str = ("0" + minute_str).slice(-2);
      second_str = ("0" + second_str).slice(-2);

      var format_str = "YYYYMMDDhhmmss";
      format_str = format_str.replace("YYYY", year_str);
      format_str = format_str.replace("MM", month_str);
      format_str = format_str.replace("DD", day_str);
      format_str = format_str.replace("hh", hour_str);
      format_str = format_str.replace("mm", minute_str);
      format_str = format_str.replace("ss", second_str);

      return format_str;
    },

    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    /** データを取得する */
    async loadData() {
      // 作業項目
      this.loadData.seasons = await this.retrieveSeasons();
      // ほ場内作業のみ抽出する
      this.loadData.seasons = this.loadData.seasons.filter(
        (e) => !e.is_not_paddy_field_item
      );

      // 画像,色を追加する
      for (const season of this.loadData.seasons) {
        for (const item of season.items) {
          item.item_details.push({
            item_detail_name: "画像",
            item_detail_type: "image",
            key: "image",
          });
        }
        if (!season.color) {
          season.color = "#1a82b7";
        }
      }

      // 田圃
      await this.retrievePaddyFields(this.management_id);
      this.loadData.paddyFields = this.getPaddyFields();
      // 作業履歴のサマリを取得
      this.loadData.workHistorySummaries =
        await this.retrievePaddyFieldHistories(this.management_id);
      // 作業履歴
      for (let cnt = 0; cnt < this.loadData.paddyFields.length; cnt++) {
        const paddyField = this.loadData.paddyFields[cnt];
        const workHistories = this.loadData.workHistorySummaries.data.filter(
          (e) => e.paddy_field_id === paddyField.paddy_field_id
        );
        paddyField.workHistories = workHistories;
        paddyField["no"] = cnt + 1;
      }
      // 田圃外作業
      this.loadData.globalWorkHistorySummaries =
        await this.retrieveGlobalWorkHistories({
          management_id: this.management_id,
        });

      // 作業項目に対してほ場ごとの履歴がいくつ存在するか計算する
      // let actDates = {};
      for (const season of this.loadData.seasons) {
        for (const item of season.items) {
          item.item_header_cnt = 1;
          for (const paddy of this.loadData.paddyFields) {
            const _tmp = paddy.workHistories.filter((e) => e.item_id === item.item_id);
            if (item.item_header_cnt < _tmp.length) {
              item.item_header_cnt = _tmp.length;
            }
          }
        }
      }
    },

    /** データを成形 */
    async createDownloadData() {
      // ----------------
      // ヘッダー部分の作成
      // ----------------
      this.hideColumns = [5, 6, 7];
      let columnCount = 0;
      for (let i = 0; i < this.paddyHeaders.length; i++) {
        columnCount++;
        this.headers[0].push({
          class: "fixed02 hidden-cell",
          value: "",
          style: {
            color: "#d0e996",
            background: "#d0e996",
            borderRight: "solid 1px #d0e996",
            borderLeft: "solid 1px #d0e996",
            "--before-border": "solid 1px #d0e996",
          },
        });
      }
      this.headers[0][0].class = "fixed01 heading-cell no-cell";
      this.headers[0][1].class = "fixed01 heading-cell paddy-name-cell";
      this.headers[0][1].style["overflow-x"] = "unset";

      // Itemsテーブルのヘッダを作成する
      let itemHeaders = [];
      for (const season of this.loadData.seasons) {
        for (const item of season.items) {
          for (let i = 0; i < item.item_header_cnt; i++) {
            let nameTimes = "";
            if (item.item_header_cnt > 1) {
              nameTimes = "(" + (i + 1) + ")";
            }
            this.headers[0].push({
              class: "fixed02 heading-cell",
              value: item.item_name + nameTimes,
              style: {
                background: season.color,
                color: "white",
                borderRight: "solid 1px " + season.color,
                borderLeft: "solid 1px " + season.color,
                "--before-border": "solid 1px " + season.color,
              },
            });
            for (const item_detail of item.item_details) {
              var unit = "";
              if (item_detail.item_detail_unit) {
                unit += " [" + item_detail.item_detail_unit + "]";
              }
              itemHeaders.push({
                class: "fixed03",
                season_id: item.season_id,
                item_id: item.item_id,
                detail: item_detail,
                value: item_detail.item_detail_name + unit,
                item_index: i,
                is_not_paddy_field_item: item.is_not_paddy_field_item,
                style: {
                  background: "white",
                  color: season.color,
                  "--before-border": "solid 1px #ddd",
                },
              });
              this.headers[0].push({
                class: "fixed02 hidden-cell",
                value: "",
                style: {
                  background: season.color,
                  color: "white",
                  borderRight: "solid 1px " + season.color,
                  borderLeft: "solid 1px " + season.color,
                  "--before-border": "solid 1px " + season.color,
                },
              });
              // 自動計算項目
              if (item_detail.item_detail_auto) {
                var unitAuto = "";
                if (item_detail.item_detail_unit) {
                  unitAuto = " [" + item_detail.item_detail_unit + "/10a]";
                }
                else {
                  unitAuto = " [/10a]";
                }
                itemHeaders.push({
                  class: "fixed03",
                  season_id: item.season_id,
                  item_id: item.item_id,
                  detail: item_detail,
                  value: item_detail.item_detail_name + unitAuto,
                  auto: true,
                  item_index: i,
                  is_not_paddy_field_item: item.is_not_paddy_field_item,
                  style: {
                    background: "white",
                    color: season.color,
                    "--before-border": "solid 1px #ddd",
                  },
                });
                this.headers[0].push({
                  class: "fixed02 hidden-cell",
                  value: "",
                  style: {
                    background: season.color,
                    color: "white",
                    borderRight: "solid 1px " + season.color,
                    borderLeft: "solid 1px " + season.color,
                    "--before-border": "solid 1px " + season.color,
                  },
                });
              }
            }
            this.headers[0].pop();
          }
        }
      }

      this.headers[1] = this.paddyHeaders.concat(itemHeaders);
      for (const head of itemHeaders) {
        columnCount++;
        if (!head.detail.display_flg) {
          this.hideColumns.push(columnCount);
        }
        // if (head.detail.key != "1") {
        //   this.hideColumns.push(columnCount);
        // }
      }
      this.headers[1][1].style["overflow-x"] = "unset";

      // 作業項目マスタがない場合、topを0にする
      if (this.paddyHeaders.length === this.headers[1].length) {
        this.headers[1].forEach(element => {
          element.style["top"] = "0px"
        });
      }


      // ----------------
      // 表の項目を作成
      // ----------------
      this.items = [];

      // 開始日・終了日の集計
      var startDays = [];
      var endDays = [];
      var workHistoryCount = 0;
      for (const paddyHeader of this.paddyHeaders) {
        if (paddyHeader.key === "no") {
          startDays.push({
            class: "fixed02 no-cell",
            value: "-",
            style: {
              "--before-border": "solid 1px #d0e996",
            },
          });
          endDays.push({
            class: "fixed02 no-cell",
            value: "-",
            style: {
              "--before-border": "solid 1px #d0e996",
            },
          });
        } else if (paddyHeader.key === "name") {
          startDays.push({
            class: "fixed02 paddy-name-cell",
            value: "開始日",
            style: {
              "--before-border": "solid 1px #d0e996",
            },
          });
          endDays.push({
            class: "fixed02 paddy-name-cell",
            value: "終了日",
            style: {
              "--before-border": "solid 1px #d0e996",
            },
          });
        } else {
          startDays.push({
            class: "",
            value: "",
            style: null,
          });
          endDays.push({
            class: "",
            value: "",
            style: null,
          });
        }
      }


      for (const season of this.loadData.seasons) {
        for (const item of season.items) {
          for (let i = 0; i < item.item_header_cnt; i++) {
            let workHistories;
            if (item.is_not_paddy_field_item) {
              workHistories =
                this.loadData.globalWorkHistorySummaries.data.filter(
                  (e) => e.item_id === item.item_id
                );
            } else {
              workHistories = this.loadData.workHistorySummaries.data.filter(
                (e) => e.item_id === item.item_id
              );
            }
            // 作業日のitem_detailを特定
            var workDayItem = item.item_details.reduce((a, b) =>
              // a.key < b.key ? a : b
              a.display_flg ? a : b
            );
            var maxDay = null; // 日付の最大値
            var minDay = null; // 日付の最小値
            if (workHistories.length > 0) {
              let tmpWorkHistories;
              if (item.is_not_paddy_field_item) {
                // ほ場外作業
                tmpWorkHistories = workHistories;
              }
              else {
                // ほ場内作業
                tmpWorkHistories = workHistories;
              }
              maxDay = tmpWorkHistories.reduce((a, b) => {
                if (!a.work_items[workDayItem.item_detail_id]) {
                  return b;
                }
                if (!b.work_items[workDayItem.item_detail_id]) {
                  return a;
                }
                return a.work_items[workDayItem.item_detail_id] >
                  b.work_items[workDayItem.item_detail_id]
                  ? a
                  : b;
              });
              minDay = tmpWorkHistories.reduce((a, b) => {
                if (!a.work_items[workDayItem.item_detail_id]) {
                  return b;
                }
                if (!b.work_items[workDayItem.item_detail_id]) {
                  return a;
                }
                return a.work_items[workDayItem.item_detail_id] <
                  b.work_items[workDayItem.item_detail_id]
                  ? a
                  : b;
              });
            }
            
            if (
              item.is_not_paddy_field_item &&
              workHistoryCount < workHistories.length
            ) {
              // 田圃外作業の場合
              workHistoryCount = workHistories.length;
            }
            for (const itemDetail of item.item_details) {
              if (itemDetail.item_detail_id == workDayItem.item_detail_id) {
                startDays.push({
                  class: "",
                  value: minDay
                    ? minDay.work_items[workDayItem.item_detail_id]
                    : "",
                });
                endDays.push({
                  class: "",
                  value: maxDay
                    ? maxDay.work_items[workDayItem.item_detail_id]
                    : "",
                });
              } else {
                startDays.push({
                  class: "",
                  value: "",
                });
                endDays.push({
                  class: "",
                  value: "",
                });
                // 自動計算項目
                if (itemDetail.item_detail_auto) {
                  startDays.push({
                    class: "",
                    value: "",
                  });
                  endDays.push({
                    class: "",
                    value: "",
                  });
                }
              }
            }
          }
        }
      }
      this.items.push(startDays);
      this.items.push(endDays);


      // 田圃外作業の集計
      this.hideRows = [];
      var outofPaddyWorkItems = Array(workHistoryCount)
        .fill()
        .map(() => Array(columnCount));
      for (let i = 0; i < outofPaddyWorkItems.length; i++) {
        this.hideRows.push("row_id" + (this.items.length + i));
      }
      var itemCount = this.paddyHeaders.length;
      for (let i = 0; i < this.paddyHeaders.length; i++) {
        for (let j = 0; j < workHistoryCount; j++) {
          if (this.paddyHeaders[i].key === "no") {
            outofPaddyWorkItems[j][i] = {
              class: "fixed02 no-cell",
              value: "-",
              style: {
                "--before-border": "solid 1px #d0e996",
              },
            };
          } else if (this.paddyHeaders[i].key === "name") {
            outofPaddyWorkItems[j][i] = {
              class: "fixed02 paddy-name-cell",
              value: "ほ場外作業",
              style: {
                "--before-border": "solid 1px #d0e996",
              },
            };
          } else {
            outofPaddyWorkItems[j][i] = {
              class: "",
              value: "",
              style: null,
            };
          }
        }
      }

      for (const season of this.loadData.seasons) {
        for (const item of season.items) {
          const workHistories =
            this.loadData.globalWorkHistorySummaries.data.filter(
              (e) => e.item_id === item.item_id && item.is_not_paddy_field_item
            );
          // 実施日のIDを取得する
          let detailId;
          for (const itemDetail of item.item_details) {
            if (itemDetail.display_flg) {
              detailId = itemDetail.item_detail_id;
              break;
            }
          }
          // 実施日の昇順でソート
          if (detailId) {
            workHistories.sort(function(a, b) {
              if (a.work_items[detailId] > b.work_items[detailId]) return 1;
              else if (b.work_items[detailId] >= a.work_items[detailId]) return -1;
              else return 0;
            });
          }


          // 自動計算項目数算出
          let cntAuto = 0;
          for (let i = 0; i < item.item_details.length; i++) {
            // 自動計算項目
            if (item.item_details[i].item_detail_auto) {
              cntAuto++;
            }
          }
          let cntItem = item.item_details.length + cntAuto;
          cntItem = cntItem * item.item_header_cnt;
          for (let i = 0; i < cntItem ; i++) {
            for (let j = 0; j < workHistoryCount; j++) {
              outofPaddyWorkItems[j][itemCount + i] = {
                class: "",
                value: "",
                image: false,
              };
            }

            for (let j = 0; j < workHistories.length; j++) {
              if (item.item_details[i].key === "image") {
                if (
                  workHistories[j].image_paths &&
                  workHistories[j].image_paths.length > 0
                ) {
                  outofPaddyWorkItems[j][itemCount + i].value = "有";
                  outofPaddyWorkItems[j][itemCount + i].image = true;
                  outofPaddyWorkItems[j][itemCount + i].class = "image-cell";
                  outofPaddyWorkItems[j][itemCount + i].image_paths =
                    workHistories[j].image_paths;
                }
              } else {
                if (
                  workHistories[j].work_items &&
                  workHistories[j].work_items[
                    item.item_details[i].item_detail_id
                  ]
                ) {
                  outofPaddyWorkItems[j][itemCount + i].value =
                    workHistories[j].work_items[
                      item.item_details[i].item_detail_id
                    ];
                }
              }
            }
          }
          itemCount += cntItem;
        }
      }
      this.items = this.items.concat(outofPaddyWorkItems);

      // ほ場内作業の開始インデックス
      const indexItemsStart = this.items.length;

      // 田圃作業の集計
      for (const paddyField of this.loadData.paddyFields) {
        // 田圃の表項目作成
        let values = [];
        for (const paddyHeader of this.paddyHeaders) {
          let value = {
            class: "",
            value: "",
            style: null,
          };
          // cssクラスの設定
          if (paddyHeader.key == "no") {
            value.class = "fixed02 no-cell";
            value.style = {
              "--before-border": "solid 1px #d0e996",
            };
          }
          if (paddyHeader.key == "name") {
            value.class = "fixed02 paddy-name-cell";
            value.style = {
              "--before-border": "solid 1px #d0e996",
            };
          }
          // 値の設定
          if (paddyField[paddyHeader.key]) {
            value.value = paddyField[paddyHeader.key];
          }
          values.push(value);
        }

        // ほ場の履歴をMap形式に変換する
        let _tmpWorkHistoriesMap = {};
        for (const workHistory of paddyField.workHistories) {
          const mapKey = workHistory.season_id + ":" + workHistory.item_id;
          if (!_tmpWorkHistoriesMap[mapKey]) {
            _tmpWorkHistoriesMap[mapKey] = [];
            _tmpWorkHistoriesMap[mapKey].push(workHistory);
          }
          else {
            _tmpWorkHistoriesMap[mapKey].push(workHistory);
          }
        }

        // 実施日の昇順でソート
        var allKeys = Object.keys(_tmpWorkHistoriesMap);
        for (const mapkey of allKeys) {
          if (_tmpWorkHistoriesMap[mapkey].length > 1) {
            const datakeys = mapkey.split(":");
            // マスタの実施日のIDを取得する
            const _tmpSeason = this.loadData.seasons.find((m) => m.season_id == datakeys[0]);
            if (!_tmpSeason) {
              continue;
            }
            const _tmpItem = _tmpSeason.items.find((m) => m.item_id == datakeys[1]);
            if (!_tmpItem) {
              continue;
            }
            const _tmpDetail = _tmpItem.item_details.find((m) => m.display_flg);
            if (!_tmpDetail) {
              continue;
            }
            _tmpWorkHistoriesMap[mapkey].sort(function (a, b) {
              if (a.work_items[_tmpDetail.item_detail_id] > b.work_items[_tmpDetail.item_detail_id]) return 1;
              else if (b.work_items[_tmpDetail.item_detail_id] >= a.work_items[_tmpDetail.item_detail_id]) return -1;
              else return 0;
            });
          }
        }

        // 田圃毎の作業項目作成
        for (const itemHeader of itemHeaders) {
          let value = {
            class: "",
            value: "",
            image: false,
          };
          const mapKey = itemHeader.season_id + ":" + itemHeader.item_id; 
          if (_tmpWorkHistoriesMap[mapKey]) {
            if (itemHeader.item_index < _tmpWorkHistoriesMap[mapKey].length) {
              const workHistory = _tmpWorkHistoriesMap[mapKey][itemHeader.item_index];
              if (
                workHistory.work_items !== undefined &&
                workHistory.work_items[itemHeader.detail.item_detail_id] !==
                  undefined
              ) {
                if (itemHeader.auto) {
                  if (
                    workHistory.work_items_auto !== undefined &&
                    workHistory.work_items_auto[itemHeader.detail.item_detail_id] !==
                      undefined
                  ) {
                    value.value =
                      workHistory.work_items_auto[itemHeader.detail.item_detail_id];
                  }
                }
                else {
                  value.value =
                    workHistory.work_items[itemHeader.detail.item_detail_id];
                }
              } else {
                // 画像列の場合、アイコン表示
                if (itemHeader.detail.key === "image") {
                  if (
                    workHistory.image_paths &&
                    workHistory.image_paths.length > 0
                  ) {
                    value.value = "有";
                    value.image = true;
                    value.class = "image-cell";
                    value.image_paths = workHistory.image_paths;
                  }
                }
              }
            }
          }
          values.push(value);
        }
        this.items.push(values);
      }

      for (let i = 0; i < this.headers[1].length; i++) {
        // 開始日、終了日を置換する
        if (this.headers[1][i].detail && this.headers[1][i].detail.display_flg) {
          // ほ場内作業だけ置換する
          if (!this.headers[1][i].is_not_paddy_field_item) {
            let startDate = "";
            let endDate = "";
            for (let j = indexItemsStart; j < this.items.length; j++) {
              if (this.items[j][i].value) {
                if (!startDate) {
                  startDate = this.items[j][i].value;
                }
                if (!endDate) {
                  endDate = this.items[j][i].value;
                }
                if (startDate > this.items[j][i].value) {
                  startDate = this.items[j][i].value;
                }
                if (endDate < this.items[j][i].value) {
                  endDate = this.items[j][i].value;
                }
              }
            }
            this.items[0][i].value = startDate;
            this.items[1][i].value = endDate;
          }
        }
      }

      // デバッグ用コード
      // for(i = -300; i < 0; i++){
      //   // 田圃の表項目作成
      //   let values = [];
      //   for(const paddyHeader of this.paddyHeaders){
      //     let value = {
      //       class: "",
      //       value: "",
      //     };
      //     // cssクラスの設定
      //     if(paddyHeader.key == "name"){
      //       value.class = "fixed02";
      //       value.value = i;
      //     }
      //     values.push(value);
      //   }

      //   // 田圃毎の作業項目作成
      //   for(const itemHeader of itemHeaders){
      //     itemHeader;
      //     let value = {
      //       class: "",
      //       value: "",
      //     };
      //     values.push(value);
      //   }
      //   this.items.push(values);
      // }
      // デバッグ用コードここまで
      this.displayDataCreated = true;
    },

    async initHideStyle() {
      // 列の非表示設定
      // 新しいstyle要素を作成
      this.hdeStyle = document.createElement("style");
      this.hdeStyle.type = "text/css";
      // CSSの内容を書く
      this.hdeStyle.innerText = "";
      for (const col of this.hideColumns) {
        this.hdeStyle.innerText +=
          "table tr > *:nth-child(" + col + "){ display: none; }";
      }
      document.getElementsByTagName("head").item(0).appendChild(this.hdeStyle);

      for (const rowID of this.hideRows) {
        let row = document.getElementById(rowID);
        if (row) {
          row.style.display = "none";
        }
      }
    },

    // 行の非表示設定
    displayToggle() {
      // style要素を着脱して表示/非表示セルの切り替え
      if (this.displayAllItemDetails) {
        document
          .getElementsByTagName("head")
          .item(0)
          .removeChild(this.hdeStyle);
      } else {
        document
          .getElementsByTagName("head")
          .item(0)
          .appendChild(this.hdeStyle);
      }
    },

    displayToggleWorks() {
      if (this.displayAllWorks) {
        for (const rowID of this.hideRows) {
          let row = document.getElementById(rowID);
          if (row) {
            row.style.display = "";
          }
        }
      } else {
        for (const rowID of this.hideRows) {
          let row = document.getElementById(rowID);
          if (row) {
            row.style.display = "none";
          }
        }
      }
    },

    destroyStyle() {
      if (this.displayAllItemDetails) {
        return;
      }
      document.getElementsByTagName("head").item(0).removeChild(this.hdeStyle);
    },

    async displayImage(item) {
      this.showImageUrls = [];
      for (const path of item.image_paths) {
        const url = await Storage.get(path);
        this.showImageUrls.push(url);
      }
      this.showImages = true;
    },
    hideImages() {
      this.showImages = false;
      this.showImageUrls = [];
    },
  },
};
</script>

<style lang="scss">
.archivesWorkPaddy {
  // .header {
  //   margin: 2rem 2rem 1rem 2rem;
  // }
  .table-section {
    overflow: auto;
    width: auto;
    height: calc(100% - 130px);
    max-height: calc(100vh - 170px);
    position: relative;
    margin-top: 10px;
    margin-left: 2rem;
    margin-right: 2rem;
  }
  table {
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    overflow: auto; /*スクロールさせる*/
    white-space: nowrap; /*文字の折り返しを禁止*/
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;
  }
  th:nth-child(0) {
    border-right: none;
  }
  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
  }
  td:nth-child(0) {
    border-right: none;
  }

  .fixed01,
  .fixed02,
  .fixed03,
  .fixed04 {
    position: sticky;
    top: 0;
    left: 0;
    color: #222;
    background: #d0e996;
    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: 100%;
      height: 100%;
      // border: 1px solid #316409;
      border: var(--before-border);
    }
  }
  .fixed01 {
    z-index: 4;
  }
  .fixed02 {
    z-index: 1;
  }
  .fixed03 {
    z-index: 2;
    top: 38px;
  }
  .fixed04 {
    z-index: 3;
    top: 38px;
  }
  .heading-cell {
    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: 100%;
      height: 100%;
      // border-right: 1px solid #d0e996;
      border-right: var(--before-border);
    }
  }
  .hidden-cell {
    color: #d0e996;
    background: #d0e996;
    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: 100%;
      height: 100%;
      border-left: var(--before-border);
      border-right: var(--before-border);
    }
  }
  .no-cell {
    max-width: 42px;
    min-width: 42px;
    text-align: center;
  }
  .paddy-name-cell {
    left: 41px;
    max-width: 300px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    border-top: 1px solid #d0e996;
    border-left: 1px solid #d0e996;
  }
  .image-cell {
    cursor: pointer;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }
  #edit-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  #edit-area span {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }
  .button-area {
    width: auto;
    height: calc(100% - 130px);
    position: relative;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-top: 2rem;

    .btn-submit {
      position: relative;
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }

    .message-submit {
      position: relative;
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      color: var(--col1);
    }

    input[type="checkbox"] {
      display: none;
    }
    input[type="checkbox"] + label {
      padding: 0 20px 0 0;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    input[type="checkbox"] + label:before {
      display: inline-block;
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
        left;
      background-size: 24px 24px;
      padding: 0 8px 0 0;
    }
    input[type="checkbox"]:checked + label:before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
        left;
      background-size: 24px 24px;
      display: inline-block;
    }
    #label1 {
      margin-right: 160px;
    }
  }
  .message-area {
    width: auto;
    height: auto;
    position: relative;
    margin-left: 2rem;
    margin-right: 2rem;

    .error-message {
      color: var(--col1);
    }
  }
  .ic-images {
    background: url("~@/assets/icons/ic_photo_active.svg") no-repeat center
      center;
    height: 20px;
    width: 20px;
    display: block;
  }
  .image-frame-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 95;

    .image-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      height: 80vh;
      // max-height: 80vh;
      // overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    .image-title-area {
      width: 100%;
      height: 60px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      // border-bottom: solid 1px #ddd;
    }

    .image-footer-area {
      width: 100%;
      height: 20px;
      padding: 0;
      // border-top: solid 1px #ddd;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    .section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 80px);
      position: relative;

      .container {
        margin: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        &.center {
          justify-content: center;
          align-items: center;
        }

        div {
          margin: 10px;
          max-width: calc(100% - 20px);
          max-height: calc(100% - 20px);
        }

        img {
          margin: auto;
          max-width: 100%;
          max-height: 100%;
          // max-height: calc(100% - 80px);
          display: block;
        }
      }
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
  }

  .button-text {
    z-index: 1;
  }

  .spinner-overlay {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }

  .spinner {
    width: 18px;
    height: 18px;
    border: 3px solid white;
    border-top: 3px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
